import { Share } from '@hungryroot/icons';
import {
  IconButton,
  type IconButtonProminenceVariant,
  type IconButtonSizeVariant,
  type IconButtonStyleVariant,
} from '@hungryroot/ramen';

export interface ShareButtonProps {
  onClick: () => void;
  className?: string;
  size?: IconButtonSizeVariant;
  style?: IconButtonStyleVariant;
  prominence?: IconButtonProminenceVariant;
}

export function ShareButton(props: ShareButtonProps) {
  const {
    onClick,
    className,
    size = 'small',
    style = 'inverted',
    prominence = 'primary',
  } = props;
  return (
    <IconButton
      ariaLabel="Share"
      className={className}
      size={size}
      style={style}
      prominence={prominence}
      onClick={onClick}
      icon={<Share />}
    ></IconButton>
  );
}
